var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAppMenu = function SvgAppMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12976"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9915"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9913",
    transform: "rotate(90 10.115 12)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 202",
    cx: 3.372,
    cy: 3.372,
    r: 3.372,
    fill: "#222b45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 203",
    transform: "translate(13.487)",
    fill: "rgba(34,43,69,0)",
    stroke: "#6135fb",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.372,
    cy: 3.372,
    r: 3.372,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.372,
    cy: 3.372,
    r: 2.622,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9914",
    transform: "rotate(90 3.371 5.257)",
    fill: "#222b45"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 202",
    cx: 3.372,
    cy: 3.372,
    r: 3.372
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 203",
    cx: 3.372,
    cy: 3.372,
    r: 3.372,
    transform: "translate(13.487)"
  }))))));
};

export { SvgAppMenu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iR3JvdXBfMTI5NzYiIGRhdGEtbmFtZT0iR3JvdXAgMTI5NzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuNDM0IDEuODg1KSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzc2MjkiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDc2MjkiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNDM0IC0xLjg4NSkiIGZpbGw9IiNmZmYiIG9wYWNpdHk9IjAiLz4KICAgIDxnIGlkPSJHcm91cF85OTE1IiBkYXRhLW5hbWU9Ikdyb3VwIDk5MTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDUxKSI+CiAgICAgIDxnIGlkPSJHcm91cF85OTEzIiBkYXRhLW5hbWU9Ikdyb3VwIDk5MTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjIzIDApIHJvdGF0ZSg5MCkiPgogICAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfMjAyIiBkYXRhLW5hbWU9IkVsbGlwc2UgMjAyIiBjeD0iMy4zNzIiIGN5PSIzLjM3MiIgcj0iMy4zNzIiIGZpbGw9IiMyMjJiNDUiLz4KICAgICAgICA8ZyBpZD0iRWxsaXBzZV8yMDMiIGRhdGEtbmFtZT0iRWxsaXBzZSAyMDMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjQ4NykiIGZpbGw9InJnYmEoMzQsNDMsNjksMCkiIHN0cm9rZT0iIzYxMzVmYiIgc3Ryb2tlLXdpZHRoPSIxLjUiPgogICAgICAgICAgPGNpcmNsZSBjeD0iMy4zNzIiIGN5PSIzLjM3MiIgcj0iMy4zNzIiIHN0cm9rZT0ibm9uZSIvPgogICAgICAgICAgPGNpcmNsZSBjeD0iMy4zNzIiIGN5PSIzLjM3MiIgcj0iMi42MjIiIGZpbGw9Im5vbmUiLz4KICAgICAgICA8L2c+CiAgICAgIDwvZz4KICAgICAgPGcgaWQ9Ikdyb3VwXzk5MTQiIGRhdGEtbmFtZT0iR3JvdXAgOTkxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi43NDMgMCkgcm90YXRlKDkwKSI+CiAgICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8yMDItMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDIwMiIgY3g9IjMuMzcyIiBjeT0iMy4zNzIiIHI9IjMuMzcyIiBmaWxsPSIjMjIyYjQ1Ii8+CiAgICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV8yMDMtMiIgZGF0YS1uYW1lPSJFbGxpcHNlIDIwMyIgY3g9IjMuMzcyIiBjeT0iMy4zNzIiIHI9IjMuMzcyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy40ODcpIiBmaWxsPSIjMjIyYjQ1Ii8+CiAgICAgIDwvZz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";